import { RoleName } from 'types/role.types';

export const ExternalUsersRoles = [
  RoleName.AssetManagementConsultant,
  RoleName.IndependentAssetManagementConsultant,
  RoleName.Mandator,
];
